import { Component } from '@angular/core';
import { WellKnownRoutes } from 'app/core/enums/well-known-routes';

@Component({
  selector: 'sp-side-nav',
  templateUrl: 'side-nav.component.html',
  styleUrls: ['side-nav.component.scss'],
})
export class SideNavComponent {
  links = [
    {
      label: 'Profile',
      route: WellKnownRoutes.Profile,
    },
  ];
  questions = ['Questions', 'Contact your employer at:', 'xxx-xxx-xxxx'];
}
